/**
 * Este mixin lo vamos a utilizar para los buscadores que se utilizan en los index de cada recurso.
 */
export default {
  methods: {
    /**
     * Metodo que se lo utiliza como canal para mostrar el mensaje Procesando... cuando se hace una llamada asíncrona
     * @param {*} newLoading
     */
    onLoading(newLoading) {
      this.loading = newLoading;
    },
    /** Metodo que actualiza el datasource de la grilla de cada recurso
     * @param {*} newRow
     * @param {*} newData
     */
    onUpdateDataResource(newRow, newData) {
      this.rows = newRow;
      this.resources = newData;
    },
  },
};
